/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableJoinLink.defs.js'
export { main as default } from './disableJoinLink.defs.js'
